// src/pages/Herstellerliste.jsx
import { useEffect, useState } from "react";
import {
    Box,
    Heading,
    Button,
    Flex,
    Text,
    VStack,
    HStack,
} from "@chakra-ui/react";
import axios from "axios";
import { IconButton } from "@chakra-ui/react";
import { Search, Pencil, Trash } from "lucide-react";

export default function Herstellerliste() {
    const [hersteller, setHersteller] = useState([]);

    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_API_URL}/api/hersteller`)
            .then((res) => {
                const sorted = res.data.sort((a, b) =>
                    a.name.localeCompare(b.name, "de", { sensitivity: "base" })
                );
                setHersteller(sorted);
            })
            .catch((err) => console.error("Error loading Hersteller:", err));
    }, []);

    const handleDelete = async (id) => {
        if (window.confirm("Hersteller wirklich löschen?")) {
            await axios.delete(`${process.env.REACT_APP_API_URL}/api/hersteller/${id}`);
            setHersteller((prev) => prev.filter((h) => h.id !== id));
        }
    };

    return (
        <Box maxW="4xl" mx="auto" mt={10} p={8} bg="white" borderRadius="xl" boxShadow="lg">
            <Heading size="md" mb={6}>
                Herstellerliste
            </Heading>

            <VStack align="stretch" spacing={3}>
                {hersteller.map((h) => (
                    <Flex
                        key={h.id}
                        justify="space-between"
                        align="center"
                        p={3}
                        borderWidth="1px"
                        borderRadius="md"
                    >
                        <Text fontWeight="semibold" color="blue.600">
                            {h.name}
                            {h.typen && h.typen.length > 0 && (
                                <Text as="span" color="gray.600"> — {h.typen.join(", ")}</Text>
                            )}
                        </Text>

                        <HStack>
                            <IconButton aria-label="View" colorPalette="blue" onClick={() => (window.location.href = `/systemdaten/hersteller/${h.id}`)}>
                                <Search size={18} />
                            </IconButton>
                            <IconButton aria-label="Edit" colorPalette="green" onClick={() => (window.location.href = `/systemdaten/hersteller/edit/${h.id}`)}>
                                <Pencil size={18} />
                            </IconButton>
                            <IconButton aria-label="Delete" colorPalette="red" onClick={() => handleDelete(h.id)}>
                                <Trash size={18} />
                            </IconButton>
                        </HStack>
                    </Flex>
                ))}
            </VStack>
        </Box>
    );
}